<template>
  <div class="devicesPage">
    <el-table
      stripe
      :data="tableData"
      border
      style="width: 100%"
      height="100%"
      size="mini"
      @sort-change="sortChange"
    >
      <el-table-column
        type="index"
        :width="pagination.endIndex >= 1000 ? 80 : 50"
        align="center"
        :index="pagination.beginIndex"
      ></el-table-column>
      <el-table-column prop="sn" min-width="110" label="SN" align="center">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.device.sn ? scope.row.device.sn : '【未生成SN】'"
            placement="top"
            :open-delay="300"
          >
            <span
              class="textOverflow allowSkip"
              @click="SNClickBtn($event, scope.row)"
              >{{ scope.row.device.customerSn ? scope.row.device.customerSn : (scope.row.device.sn ? scope.row.device.sn : "【未生成SN】") }}</span
            >
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="orderNumber"
        min-width="110"
        label="组装工单"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.productionOrder">{{
            scope.row.productionOrder.orderNumber
          }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="weight" label="单品称重" min-width="110" align="center">      
        <template slot-scope="scope">
          <div class="textOverflow" v-if="scope.row.deviceWeight">
            <span :class="{expire: $parent.detailData.weight && (scope.row.deviceWeight<$parent.detailData.weight.min || scope.row.deviceWeight>$parent.detailData.weight.max)}">
              {{ scope.row.deviceWeight }}g
            </span>
          </div>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="otherSn" label="其它SN" align="center">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.otherSn" class="item" effect="dark" placement="top" min-width="110px" :open-delay="300">
            <div slot="content" style="white-space: pre-wrap; word-break: break-all;">{{ JSON.stringify(scope.row.otherSn, null, 2) }}</div>
            <div class="textOverflow">
              {{ scope.row.otherSn }}
            </div>
          </el-tooltip>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="innerCtnIndex" label="内箱" min-width="130" align="center" show-overflow-tooltip sortable="custom">
        <template slot-scope="scope">
          <template v-if="scope.row.innerCtnSn">
            <el-tooltip class="item" effect="dark" :content="scope.row.innerCtnSn" placement="top" :open-delay="300">
              <span :class="{expire : $parent.detailData.inner && (scope.row.innerCtnWeight<$parent.detailData.inner.minWeight || scope.row.innerCtnWeight>$parent.detailData.inner.maxWeight)}">
                第{{ scope.row.innerCtnIndex }}箱 {{ scope.row.innerCtnWeight ? (scope.row.innerCtnWeight+'kg') : '' }}
              </span>
            </el-tooltip>
          </template>
          <template v-else-if="scope.row.innerCtnIndex">
            <span :class="{expire : $parent.detailData.inner && (scope.row.innerCtnWeight<$parent.detailData.inner.minWeight || scope.row.innerCtnWeight>$parent.detailData.inner.maxWeight)}">
              第{{ scope.row.innerCtnIndex }}箱 {{ scope.row.innerCtnWeight ? (scope.row.innerCtnWeight+'kg') : '' }}
            </span>
          </template>
          <template v-if="scope.row.innerCtnIndex">
            <i @click="unbindInnerBtn(scope.row.innerCtnIndex)" class="item allowSkip iconfont icon-chai">&nbsp;</i>
          </template>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="outerCtnIndex" label="外箱" min-width="130" align="center" show-overflow-tooltip sortable="custom">
        <template slot-scope="scope">
          <template v-if="scope.row.outerCtnSn">
            <el-tooltip class="item" effect="dark" :content="scope.row.outerCtnSn" placement="top" :open-delay="300">
              <span :class="{expire : $parent.detailData.outer && (scope.row.outerCtnWeight<$parent.detailData.outer.minWeight || scope.row.outerCtnWeight>$parent.detailData.outer.maxWeight)}">
                第{{ scope.row.outerCtnIndex }}箱 {{ scope.row.outerCtnWeight ? (scope.row.outerCtnWeight+'kg') : ''}}
              </span>
            </el-tooltip>
          </template>
          <template v-else-if="scope.row.outerCtnIndex">
            <span :class="{expire : $parent.detailData.outer && (scope.row.outerCtnWeight<$parent.detailData.outer.minWeight || scope.row.outerCtnWeight>$parent.detailData.outer.maxWeight)}">
              第{{ scope.row.outerCtnIndex }}箱 {{ scope.row.outerCtnWeight ? (scope.row.outerCtnWeight+'kg') : ''}}
            </span>
          </template>
          <template v-if="scope.row.outerCtnIndex">
            <i @click="unbindOuterBtn(scope.row.outerCtnIndex)" class="item allowSkip iconfont icon-chai">&nbsp;</i>
          </template>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="palletIndex" label="栈板" min-width="130" align="center" show-overflow-tooltip sortable="custom">        
        <template slot-scope="scope">
          <template v-if="scope.row.palletSn">
            <el-tooltip class="item" effect="dark" :content="scope.row.palletSn" placement="top" :open-delay="300">
              <span :class="{expire : $parent.detailData.pallet && (scope.row.palletWeight<$parent.detailData.pallet.minWeight || scope.row.palletWeight>$parent.detailData.pallet.maxWeight)}">
                第{{ scope.row.palletIndex }}板 {{ scope.row.palletWeight ? (scope.row.palletWeight + 'kg') : ''}}
              </span>
            </el-tooltip>
          </template>
          <template v-else-if="scope.row.palletIndex">
            <span :class="{expire : $parent.detailData.pallet && (scope.row.palletWeight<$parent.detailData.pallet.minWeight || scope.row.palletWeight>$parent.detailData.pallet.maxWeight)}">
              第{{ scope.row.palletIndex }}板 {{ scope.row.palletWeight ? (scope.row.palletWeight + 'kg') : ''}}
            </span>
          </template>
          <template v-if="scope.row.palletIndex">
            <i @click="unbindPalletBtn(scope.row.palletIndex)" class="item allowSkip iconfont icon-chai">&nbsp;</i>
          </template>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="workStation" width="95px" label="状态" align="center">
        <template slot-scope="scope">
            <span class="textOverflow"
              v-if="scope.row.workStation"
              >{{ scope.row.workStation.name }}</span>
          <span v-if="!scope.row.workStation">-</span>
        </template>
      </el-table-column>
      <el-table-column class-name="operation" label="操作" align="center" width="95px">
        <template slot-scope="scope">
          <el-tooltip
            v-if="!scope.row.palletIndex && !scope.row.outerCtnIndex && !scope.row.innerCtnIndex"
            class="item"
            effect="dark"
            content="移除（打回组装工单）"
            placement="top"
            :open-delay="300"
          >
            <i @click="removeDevice($event, scope.row)" class="iconfont icon-yichu"></i>
          </el-tooltip>
          <span v-else>-</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :pagination="pagination"
      @currentChange="currentChange"
      @sizeChange="sizeChange"
      @refreshBtn="getCartonOrderDevices"
      :sumTotal="'/' + tabPaneData.quantity"
    ></pagination>
    <myDrawer ref="myDrawer" :drawerOption="drawerOption"></myDrawer>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDrawer from "@/components/myDrawer.vue";
import {
  apiCartonOrderDevices,
  apiCartonTypeList,
  apiCartonOrderProductionOrders,
  apiProductionOrderStatusList,
  apiUnbindOuterCarton,
  apiUnbindInnerCarton,
  apiUnbindPalletCarton,
  apiCartonOrderRemoveDevice
} from "@/api/cartonOrder.js";
export default {
  components: {
    pagination,
    myDrawer,
  },
  props: {
    tabPaneValue: {
      type: String,
    },
    tabPaneData: {
      type: Object,
    },
    devicesSearchForm: {
      type: Object,
    },
  },
  data() {
    return {
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
      drawerOption: {
        currentSNId: "",
        currentSNName: "",
      },
    };
  },
  methods: {    
    // 移除
    removeDevice(e, row) {
      e.target.blur();
      const h = this.$createElement;
      this.$msgbox({
        title: `移除产品`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入SN:【`
          ),
          h("i", { style: "color: var(--themeColor)" }, row.device.sn),
          h("span", null, `】以确认移出包装工单！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == row.device.sn) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiCartonOrderRemoveDevice({
          id: this.tabPaneValue,
          deviceId: row.device.id
        });
        if (res.code == 0) {
          this.getCartonOrderDevices("noRemove");
          this.$message({
            type: "success",
            message: "移除成功"
          });
        }
      });
    },
    // 表格数据
    async getCartonOrderDevices(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiCartonOrderDevices({
        cartonOrderId: this.tabPaneValue,
        ...this.devicesSearchForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy,
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getCartonOrderDevices();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getCartonOrderDevices();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getCartonOrderDevices();
    },
    // 产品列表表格导出
    tableExport() {
      this.$confirm(`导出数据可能需要几分钟的时间，确定导出吗？`, "导出列表", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiCartonOrderDevices({
          cartonOrderId: this.tabPaneValue,
          ...this.devicesSearchForm,
          export: true,
          desc: this.desc,
          orderBy: this.orderBy,
        });
        if (res.code == 0) {
          this.$downloadFile(res.fid, res.fileName, res.secretKey);
        }
      });
    },
    // 点击sn列
    SNClickBtn(e, row) {
      e.target.blur();
      this.drawerOption = {
        currentSNId: row.device.id,
        currentSNName: row.device.sn || "-",
      };
      this.$nextTick(() => {
        this.$refs.myDrawer.getDeviceLife();
      });
    },
    unbindInnerBtn(ctnIndex) {
      const h = this.$createElement;
      this.$msgbox({
        title: `内箱拆箱`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入内箱号:【`
          ),
          h("i", { style: "color: var(--themeColor)" }, ctnIndex),
          h("span", null, `】以确认需要解绑包装`),
        ]),
        showCancelButton: true,
        confirmButtonText: `修改`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            // 负数为解绑到“待生产”
            if (Math.abs(instance.inputValue) == ctnIndex) {
              ctnIndex = instance.inputValue;
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiUnbindInnerCarton({
          ctnIndex,
          orderId: this.tabPaneValue,
          orderType: 1
        });
        if (res.code == 0) {
          this.getCartonOrderDevices("noRemove");
          this.$message({
            message: "解绑成功",
            type: "success",
          });
        }
      });
    },
    unbindOuterBtn(ctnIndex) {
      const h = this.$createElement;
      this.$msgbox({
        title: `外箱拆箱`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入外箱号:【`
          ),
          h("i", { style: "color: var(--themeColor)" }, ctnIndex),
          h("span", null, `】以确认需要解绑包装`),
        ]),
        showCancelButton: true,
        confirmButtonText: `修改`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            // 负数为解绑到“待生产”
            if (Math.abs(instance.inputValue) == ctnIndex) {
              ctnIndex = instance.inputValue;
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiUnbindOuterCarton({
          ctnIndex,
          orderId: this.tabPaneValue,
          orderType: 1
        });
        if (res.code == 0) {
          this.getCartonOrderDevices("noRemove");
          this.$message({
            message: "解绑成功",
            type: "success",
          });
        }
      });
    },
    unbindPalletBtn(ctnIndex) {
      const h = this.$createElement;
      this.$msgbox({
        title: `栈板拆箱`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入栈板号:【`
          ),
          h("i", { style: "color: var(--themeColor)" }, ctnIndex),
          h("span", null, `】以确认需要解绑包装`),
        ]),
        showCancelButton: true,
        confirmButtonText: `修改`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            // 负数为解绑到“待生产”
            if (Math.abs(instance.inputValue) == ctnIndex) {
              ctnIndex = instance.inputValue;
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiUnbindPalletCarton({
          ctnIndex,
          orderId: this.tabPaneValue,
          orderType: 1
        });
        if (res.code == 0) {
          this.getCartonOrderDevices("noRemove");
          this.$message({
            message: "解绑成功",
            type: "success",
          });
        }
      });
    },
    // 产品列表--包装类型下拉
    async getCartonTypeList() {
      const res = await apiCartonTypeList({
        id: this.tabPaneValue,
      });
      if (res.code == 0) {
        this.$parent.pullDownData.devicesCartonTypeList = res.data;
      }
    },
    // 产品列表--组装工单下拉
    async getCartonOrderProductionOrders() {
      const res = await apiCartonOrderProductionOrders({
        id: this.tabPaneValue,
      });
      if (res.code == 0) {
        this.$parent.pullDownData.devicesProductionList = res.data.filter(
          (item) => {
            return item.id != 0;
          }
        );
      }
    },
    // 产品列表-当前工序
    async getProductionOrderStatusList() {
      const res = await apiProductionOrderStatusList({
        all: true,
        id: this.tabPaneValue,
      });
      if (res.code == 0) {
        this.$parent.pullDownData.productionOrderStatusList = res.data;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.devicesPage {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.expire {
  color: #f56c6c
}
</style>